import { createContext, useEffect, useReducer } from 'react';
import axios from 'axios';
import { MatxLoading } from 'app/components';
import { decryptString, encryptString } from 'app/utils/encrpt';
import { base_url, database, namespace } from 'app/api/config';

const initialState = {
  user: null,
  isInitialised: false,
  isAuthenticated: false
};

// const isValidToken = (accessToken) => {
//   if (!accessToken) return false;

//   const decodedToken = jwtDecode(accessToken);
//   const currentTime = Date.now() / 1000;
//   return decodedToken.exp > currentTime;
// };

// const setSession = (accessToken) => {
//   if (accessToken) {
//     localStorage.setItem('accessToken', accessToken);
//     axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
//   } else {
//     localStorage.removeItem('accessToken');
//     delete axios.defaults.headers.common.Authorization;
//   }
// };

const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT': {
      const { isAuthenticated, user } = action.payload;
      return { ...state, isAuthenticated, isInitialised: true, user };
    }

    case 'LOGIN': {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user };
    }

    case 'LOGOUT': {
      return { ...state, isAuthenticated: false, user: null };
    }

    case 'REGISTER': {
      const { user } = action.payload;

      return { ...state, isAuthenticated: true, user };
    }

    default:
      return state;
  }
};

const AuthContext = createContext({
  ...initialState,
  method: 'JWT',
  login: () => {},
  logout: () => {},
  register: () => {}
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const url_api = base_url + namespace + database;

  const login = async (email, password) => {
    const response = await axios.post(url_api + '/auth/signAdministrator', { email, password });
    const { data } = response;

    dispatch({ type: 'LOGIN', payload: { user: data } });
    let hash = encryptString(data.token, 'secret_key');
    localStorage.setItem('hash', hash);

    // localStorage.setItem('key', hash);
  };

  const register = async (email, username, password) => {
    const response = await axios.post('/api/auth/register', { email, username, password });
    const { user } = response.data;

    dispatch({ type: 'REGISTER', payload: { user } });
  };

  const logout = () => {
    localStorage.removeItem('hash');
    dispatch({ type: 'LOGOUT' });
  };

  useEffect(() => {
    (async () => {
      try {
        let getLocalStr = localStorage.getItem('hash');
        const decrp = decryptString(getLocalStr, 'secret_key');

        const response = await axios.get(url_api + '/admin/profile', {
          headers: {
            Authorization: `Bearer ${decrp ? decrp : state?.user?.token}`
          }
        });
        let resp = response.data;

        if (resp.token) {
          dispatch({ type: 'INIT', payload: { isAuthenticated: true, user: resp } });
        }
      } catch (err) {
        console.error('==>', err.message);
        dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // SHOW LOADER
  if (!state.isInitialised) return <MatxLoading />;

  return (
    <AuthContext.Provider value={{ ...state, method: 'JWT', login, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
